import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { customersRouting } from './customers.routing';

import {
    MaterialFormsModule,
    MaterialUserInterfaceModule
} from 'ng2-material-components/ng2-material-components';

import { CustomersComponent }   from './customers.component';
import { CustomersService } from './shared';
import { CustomersSearchComponent } from './customers-search';
import { CustomerInvoiceComponent } from './customer-invoices';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        ReactiveFormsModule,
        MaterialFormsModule,
        MaterialUserInterfaceModule,
        customersRouting
    ],
    exports: [
        CustomersComponent,
        CustomersSearchComponent,
        CustomerInvoiceComponent
    ],
    declarations: [
        CustomersComponent,
        CustomersSearchComponent,
        CustomerInvoiceComponent
    ],
    providers: [ CustomersService ],
})
export class CustomersModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/customers/customers.module.ts